/* eslint-disable import/no-cycle */
import Order from './order';
import ShipTo from './shipTo';
import ShipToResponse from './shipToResponse';

class CustomerResponse {
  constructor({
    id,
    name,
    email,
    phone,
    company,
    orders,
    ship_to,
    createdAt,
    updatedAt,
  }) {
    this.id = id;
    this.name = name;
    this.email = email;
    this.phone = phone;
    this.company = company;
    if (orders?.data?.length > 0) {
      this.orders = orders.data.map((order) => new Order(order));
    }
    if (ship_to) {
      this.shipTo = ship_to?.data
        ? new ShipTo(ship_to.data)
        : new ShipToResponse(ship_to);
    }
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }
}

export default CustomerResponse;
